import React from "react";

import { formatRouteDetails } from "../../helpers/formatters";

interface VedomItem {
  id: string;
  num?: string;
  name?: string;
  date?: string;
  time?: string;
  [key: string]: any;
}

interface BusMapHeaderProps {
  selectedRoute: VedomItem | null;
  onClose: () => void;
}

export const BusMapHeader: React.FC<BusMapHeaderProps> = ({
  selectedRoute,
  onClose,
}) => {
  return (
    <div className="modal-header">
      <div className="modal-title">
        <span className="modal-icon">🚌</span>
        <div className="title-content">
          <h2>Карта місць у автобусі</h2>
          {selectedRoute && (
            <p className="route-details">{formatRouteDetails(selectedRoute)}</p>
          )}
        </div>
      </div>
      <button
        className="modal-close-button"
        onClick={onClose}
        aria-label="Закрити"
      >
        ✕
      </button>
    </div>
  );
};
